export const initialState = {
  isLoading: false,
  isError: false,
  mainPage: true, // 0 for add user view and 1 for form view
  users: [],
};
